<p-confirmpopup></p-confirmpopup>
<p-toast [baseZIndex]="20000"></p-toast>
<p-dialog header=" {{ cellValue[0].toUpperCase() }}" [modal]="true" [(visible)]="dialogVisible"
  [style]="{ width: '50rem' }" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [maximizable]="true">


</p-dialog>

<div class="filter-dropdown-container-dis">

  <app-dropdown [options]="typeOptions" [(selectedValue)]="selectedType" (selectedValueChange)="onTypeChange($event)"
    aria-label="Type" placeholder="Type" [showLabel]="false" label="Type" customClass="districts-district-dropdown"
  [showFloatingLabel]="true"></app-dropdown>


  <!-- <span [ngClass]="{'p-float-label': true}">
  <p-datepicker [(ngModel)]="selectedScheduledDate" name="selectedScheduledDate" class="calender-icon"
  [showIcon]="true" (onSelect)="onScheduledDateChange($event)" dateFormat="mm/dd/yy"></p-datepicker>
  <label style="display: block; font-size: 16px; color: #02060e;">
    {{selectDate}}
  </label>
</span> -->
<app-datepicker [(ngModel)]="selectedScheduledDate" (onSelectChange)="onScheduledDateChange($event)"
[inputlabel]="selectDate"></app-datepicker>


<app-dropdown [options]="districtOptions" [(selectedValue)]="selectedDistrict"
  (selectedValueChange)="onDistrictChange($event)" aria-label="District" placeholder="District"
  [showLabel]="false" label="District" customClass="districts-district-dropdown"
[showFloatingLabel]="true"></app-dropdown>

<div>
  <button pButton type="button" label="Search" class="search-button" (click)="onSearch()"></button>

  <button pButton type="button" label="Clear" class="clear-button" (click)="onClear()"></button>
</div>
</div>

@if (isLoading) {
  <div class="loading-container">
    <p-progressSpinner>
      <style class="custom-spinner"></style>
    </p-progressSpinner>
    <p>{{ processMessage }}</p>
  </div>
}

<app-table #tblConfig [showCheckRowColumn]="false" [SingleRowSelection]="true" [columns]="lsNorthDataColumns"
  [rows$]="filteredData$" [pageSize]="10" (onAction2ButtonClicked)="onReloadClicked()" [actionButtons]="actionButtons"
  (onCellClicked)="onCellClicked($event)" [totalRecords]="totalRecords" [pageNumber]="pageNumber"
  (pageChanged)="handlePageChange($event)" (sortClicked)="onSortClicked($event)"
(onSearchText)="onSearchText($event)"></app-table>